import Welcome from '../account/Welcome.vue';
import OmTjenesten from '../shared/OmTjenesten.vue';
import Personvern from '../shared/Personvern.vue';
import Varsler from '../subscription/Varsler.vue';

const routeNames = {
  Welcome: "Welcome",
  OmTjenesten: "OmTjenesten",
  Personvern: "Personvern",
  Varsler: "Varsler",
  Info: "Info",
  All: "All",
  Routes: [],
};

routeNames.getRoute = function(routeName) {
  const found = routeNames.Routes.filter((r) => r.name.toLowerCase() === routeName.toLowerCase());
  if (found && found.length > 0) return found[0];
  return null;
};
routeNames.getPathForRoute = function(routeName) {
  const route = routeNames.getRoute(routeName);
  if (!route) return null;
  return route.path;
};

routeNames.Routes = [
  { path: '/', name: routeNames.Welcome, component: Welcome, meta: { requiresAuthentication: false } },
  { path: '/Tjenesten', name: routeNames.OmTjenesten, component: OmTjenesten, meta: { requiresAuthentication: false } },
  { path: '/Personvern', name: routeNames.Personvern, component: Personvern, meta: { requiresAuthentication: false } },
  { path: '/Varsler', name: routeNames.Varsler, component: Varsler, meta: { requiresAuthentication: true } },
  { path: '*', name: routeNames.All, redirect: '/', meta: { requiresAuthentication: false } },
];

export default Object.freeze(routeNames);
